import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ItemGeneralListado } from '../../../helpers/components/itemClasses/itemListadoGeneral.class';
import { FormulariosService } from '../../../infrastructure/services/formularios.service';
import { ElementBase } from 'app/helpers/form/elements/elementBase';

@Component({
  selector: 'configurar-formulario-producto',
  templateUrl: './configurar.formulario.component.html',
  providers: [FormulariosService]
})
export class ConfigurarFormularioProductComponent implements OnInit {
  codSubscription: string;
  codChannel: string;
  buscarChannel: String;
  formulario: ElementBase<any>[];
  cargandoFormulario: Boolean = true;
  constructor(private aRoute: ActivatedRoute, private formulariosService: FormulariosService) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.formulariosService.getFormulario('inworx').subscribe((data) => {
        this.cargandoFormulario = false;
      });
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/product/configurar.formulario.component.ts